import { DialogHeader, DialogTitle } from "@/view/components/ui/dialog";

interface HeaderProps {
  title: string;
}
export default function Header({ title }: HeaderProps) {
  return (
    <DialogHeader className="border-b border-gray01 pb-8">
      <DialogTitle className="text-xl font-semibold text-black01">
        {title}
      </DialogTitle>
    </DialogHeader>
  );
}
